import { Link } from "react-router";
import { Article } from "../../../../../models";
import { getText, sanitizeHtml } from "../../../../../utils/_generic";
import { getHighlightedExcerpts } from "../../../../../utils/_getHighlightedExcerpts";
import PDLTypography from "../../../dna/_pdltypography";

export interface ArticleItemProps {
  item: Article;
  index: number;
  legislationId: string;
  searchTerm?: string;
}

const ArticleItem = ({
  item,
  index,
  legislationId,
  searchTerm,
}: ArticleItemProps) => {
  const itemId = item.ref || `article-${index}`;

  const sanitizedHtml = sanitizeHtml(item.texto || "");
  const textOnly = getText(sanitizedHtml);

  const excerpt = searchTerm
    ? getHighlightedExcerpts(textOnly, searchTerm, 120)
    : null;
  const hasMatch = !!excerpt;

  const fallbackPreview =
    textOnly.length > 200 ? `${textOnly.slice(0, 200)}...` : textOnly;

  return (
    <div
      key={itemId}
      id={`article-item-${itemId}`}
      className="pdl_components_lista_resultados_item mt-3 article-container"
    >
      <header className="title-wrapper">
        <Link
          to={`/legislacao/${legislationId}#${item.ref}`}
          className="text-decoration-none"
        >
          <PDLTypography
            size="sm"
            weight="medium"
            variant="brand"
            upper
            className="title-link"
          >
            Art. {item.artigo}
          </PDLTypography>
        </Link>
      </header>

      <div className="text-container mt-2">
        {hasMatch && (
          <>
            <PDLTypography
              size="sm"
              weight="medium"
              className="text-gray-800 mb-1"
            >
              Texto encontrado em:
            </PDLTypography>

            <div
              className="content text-sm text-gray-800 article-text"
              dangerouslySetInnerHTML={{ __html: excerpt }}
            />
          </>
        )}

        {!hasMatch && (
          <PDLTypography size="sm" className="text-gray-800">
            {fallbackPreview}
          </PDLTypography>
        )}
      </div>
    </div>
  );
};

export default ArticleItem;
